import { api } from "lwc";

import Button, { Variant } from "tds/button";
import { PopoverPlacement } from "common/popover";
import { BooleanAttr, attrToBool } from "common/helpers";

export type Shape = "default" | "circle";

export default class extends Button {
  @api variant: Variant = "tertiary";
  @api shape: Shape = "default";
  @api tooltipPlacement: PopoverPlacement = "top";

  private _tooltipDisabled = false;
  @api
  get tooltipDisabled() {
    return this._tooltipDisabled;
  }

  set tooltipDisabled(newValue: BooleanAttr) {
    this._tooltipDisabled = attrToBool(newValue);
  }

  private get shapeClassName() {
    return this.shape !== "default" ? `button--${this.shape}` : "";
  }

  get className() {
    return `${super.className} ${this.shapeClassName}`.trim();
  }

  renderedCallback() {
    // Disable browser UI since custom tooltips are included
    this.removeAttribute("title");
  }

  private handleMouseDown() {
    this._tooltipDisabled = true;
  }

  private handleMouseUp() {
    this._tooltipDisabled = false;
  }
}
